import { compact } from '@direct-frontend/stdlib';
import type { Reactify } from '@yandex/ymaps3-types/reactify';

import { YMapAddon } from '../constants';

import { loadHint } from './loadHint';
import { loadClusterer } from './loadClusterer';
import { loadDefaultUITheme } from './loadDefaultUITheme';
import { loadDefaultUIThemeCss } from './loadDefaultUIThemeCss';
import { loadControlsExtra } from './loadControlsExtra';
import { loadRuler } from './loadRuler';

/**
 * Загрузка опциональных дополнений
 * @param addonNames Наименования подключаемых дополнений
 * @param reactify Метод получения react-версий дополнений
 * @kind helper
 * @returns Промис получения указанных дополнений
 */
export const loadAddons = async (addonNames: Array<YMapAddon>, reactify: Reactify) => {
    const packages = await Promise.allSettled(compact(addonNames.map(addonName => getLoader(addonName))));

    return packages.reduce(
        (acc, addonPromise, index) => ({
            ...acc,
            [String(addonNames[index])]:
                addonPromise.status === 'fulfilled' ? reactify.module(addonPromise.value) : null,
        }),
        {}
    );
};

/**
 * Получение нужного загрузчика по типу
 * @param addonName Наименование дополнения
 * @returns Соответствующий загрузчик по наименованию дополнения
 */
const getLoader = (addonName: YMapAddon) => {
    switch (addonName) {
        case YMapAddon.hint:
            return loadHint();
        case YMapAddon.clusterer:
            return loadClusterer();
        case YMapAddon.defaultUITheme:
            return loadDefaultUIThemeCss().then(() => loadDefaultUITheme());
        case YMapAddon.controlsExtra:
            return loadControlsExtra();
        case YMapAddon.ruler:
            return loadRuler();
        default:
            return null;
    }
};
